"use client";

import { useSearch } from "@/context/SearchContext";
import { useLocalizedData } from "@/context/LocaleContext";
import { I18nData } from "@/types/i18n";
import { useMemo } from 'react';
import "./pagination.scss";
import React from "react";

interface PaginationProps {
  i18nData?: I18nData;
}

const Pagination = React.memo(function Pagination({ i18nData }: PaginationProps) {
  const { searchResult, currentSearchTerm, filters, search } = useSearch();
  const skip = searchResult?.data.length ?? 0;
  const localizedData = useLocalizedData(i18nData);
  
  const showMoreText = useMemo(() => {
    return localizedData?.show_more || "Show more";
  }, [localizedData]);
  
  if (!searchResult) return null;
  if (!searchResult.has_more) return null;
  
  return (
    <div id="showMore" className="block">
      <button
        id="showMoreButton"
        aria-label="Load additional search results"
        onClick={() => search(currentSearchTerm ?? "", filters, false, skip)}
      >
        {showMoreText}
      </button>
    </div>
  );
});

export default Pagination;
